import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Select from "react-select";
import ReactDatatable from "@ashvin27/react-datatable";
import EditUsersModal from "../Modals/EditUsersModal";
import DeleteUsersModal from "../Modals/DeleteUsersModal";
import AddUsersModal from "../Modals/AddUserModal";
import { getUserList } from "../actions/admin";
import Exportexcel from "../Components/Excelexport";
import Papa from "papaparse";
import { addNewUserCSV } from "../actions/admin";
import toast from "react-hot-toast";
import EditEmailTemplateModal from "../Modals/EditEmailTemplate";

import { getEmailTemplates } from "../actions/admin";
import AddEmailTemplateModal from "../Modals/AddEmailTemplateModal";

const EmailTemplate = () => {



  const [templateList, settemplateList] = useState(
    // [
    //   {
    //     subject: "Lorem",
    //     identifier: "Lorem",
    //   },
    // ]
  );

  // edid Exchange modal
  const [showEditUser, setShowEditUser] = useState(false);
  const [editRecord, setEditRecord] = useState();

  const [pageNumer, setPageNumer] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [showAddToken, setShowAddToken] = useState(false);

  const handleShowAddToken = () => setShowAddToken(true);

  const handleCloseAddToken = () => setShowAddToken(false);

  const handleShowEditUser = (record) => {
    setEditRecord(record);
    setShowEditUser(true);
  };

  const handleCloseEditUser = () => {
    setShowEditUser(false);
    setEditRecord({});
  };




  const handlePagination = async (index) => {
    let reqData = {
      page: index.page_number,
      limit: index.page_size,
    };
    // let skip = (index.page_number - 1) * index.page_size;
    // let loadinterval = index.page_number * index.page_size;
    setPageNumer(index.page_number);
    setLimit(index.page_size);
    const { status, message, data, count } = await getEmailTemplates(reqData);

    settemplateList(data);
    setCount(count);
    // setInterval(loadinterval);
  };
  const getTemplates = async () => {
    let reqData = {
      page: pageNumer,
      limit: limit,
    };
    
    let { status, message, data, count } = await getEmailTemplates(reqData)
    console.log("🚀 ~ getTemplates ~ status, message, data:", status, message, data)
    settemplateList(data)
    setCount(count)
  }


  useEffect(() => {
    getTemplates();
  }, []);




  const columns = [
    {
      key: "subject",
      text: "Subject",
      className: "text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "identifier",
      text: "Identifier",
      className: "text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "action",
      text: "Action",
      className: "activity",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button
              className="cmn_plain_btn"
              onClick={() => {
                handleShowEditUser(record);
              }}
            >
              <img
                src={require("../assets/images/editer.svg").default}
                className="img-fluid table_activity_img"
              />{" "}
            </button>
          </div>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Emailtemplates",
    no_data_text: "No Email Templates found!",
    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: "Previous",
        next: "Next",
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: false,
  };

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={"Email Templates"} />
            <div className="text-end mb-4 mt-4">
              <button
                className="orange_small_primary"
                onClick={() => {
                  handleShowAddToken(true);
                }}>
                Add
              </button>
            </div>
            {/* <div className="rp_singleinput_holder mb-3"> */}
            {/* <Row>
                <Col md={6} sm={8} xs={12}>
                <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  placeholder="Search..."
                  name="name"
                  className="rp_singleInput flex-grow-1"
                />
              </div>
                </Col>
              </Row> */}
            {/* </div> */}
            <div className="common_page_scroller pb-5 mt-3 mt-sm-5 pe-2">
              <div className="exchange_table_holder dashboard_box rounded-3 mt-4 tabletop">
                <ReactDatatable
                  config={config}
                  records={templateList}
                  columns={columns}
                  dynamic={true}
                  total_record={count}
                  onChange={(e) => {
                    handlePagination(e);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* modals */}
      <EditEmailTemplateModal
        show={showEditUser}
        record={editRecord}
        getTemplates={getTemplates}
        handleClose={handleCloseEditUser} />
      {/* end of modals */}

      <AddEmailTemplateModal
        show={showAddToken}
        getTemplates={getTemplates}
        handleClose={handleCloseAddToken} />
      
    </>
  );
};

export default EmailTemplate;
